import { render, staticRenderFns } from "./ControlePermissoes.vue?vue&type=template&id=1699026c"
import script from "./ControlePermissoes.vue?vue&type=script&lang=js"
export * from "./ControlePermissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports